export default __webpack_public_path__ + "static/media/japandi-mobile.94bd2342.jpg";